import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import AdminDashboardPage from './components/AdminDashboardPage';
import Loader from '../Loader';
import * as RFIcon from 'react-feather'; 
import { Box, Grid, Typography, AppBar, Toolbar, Icon, Divider } from '@material-ui/core';
import ManagerDashboardPage from './components/ManagerDashboard';
import language from '../../languages';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    //   paddingTop: 20
    },
    container: {
        padding: theme.spacing(3),
    },
    paper: {
        height: 170,
        width: 200,
    },
    control: {
        padding: theme.spacing(2),
    },
    appBar: {
        boxShadow: 'none',
    },
    headTitle: {
        flexGrow: 1,
        color: '#09205C'
    },
    titleIcon: {
        color: '#09205C',
        marginRight: theme.spacing(2)
    },
    divider: {
        backgroundColor:"#2735A4",
        height: 2
    },
    activitiesArea: {
        // height: '73vh',
        overflow: 'auto',
        backgroundColor:'#ffffff', 
        boxShadow:'5px 5px 20px rgba(39, 53, 164, 0.21)', 
        borderRadius:10
    },
    box: {
        backgroundColor:'#ffffff', 
        boxShadow:'5px 5px 20px rgba(39, 53, 164, 0.21)', 
        borderRadius:10
    },
    title: {
        flexGrow: 1,
        padding: '8px 16px',
        color: '#09205C',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        borderBottom: '1px solid rgba(9, 32, 92, 0.4)',
    },
}));

function DashboardPage(props) {
    const classes = useStyles();
    const [loading, setLoading] = useState(true)
    const { userData, appSettings } = props

    const lang = appSettings ? (appSettings.language ? appSettings.language: 'en') : 'en';
    
    const currentRole = userData ? (userData.roles ? userData.roles[0]: 'NA') : 'NA';

    useEffect(() => {
       setLoading(false)
    }, []);

    return (
        <Box>
            {loading ? <Loader /> :
            <Grid container>
                <Grid item xs={12}>
                    <AppBar color="transparent" position="static" className={classes.appBar}>
                        <Toolbar>
                            <Icon className={classes.titleIcon}>
                                <RFIcon.PieChart strokeWidth={2} />
                            </Icon>
                            <Typography className={classes.headTitle} variant="h6" noWrap>
                                {language[lang].Dashboard}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <Divider className={classes.divider} />
                </Grid>
                {
                    currentRole == 'MANAGER' ? 
                        <ManagerDashboardPage classes={classes} lang={lang} /> 
                    :
                        <AdminDashboardPage classes={classes} lang={lang} />
                }
            </Grid>
            }
        </Box>
    )
}

export default DashboardPage

